// ICD-10 lookup. Same controlled pairing as SnomedSearchField: the parent owns
// both the code and the display, typing clears the code, and only picking a
// catalog row sets them together. Local catalog — no network.

import React, { useMemo, useRef, useState } from "react";
import IpdTextField from "../../ipd/utils/IpdTextField";
import { C } from "../constants";
import SvgIcon from "../SvgIcon";
import { searchIcd10 } from "../icd10-catalog";

const listStyle = {
  background: "#f8f9fa",
  border: `1px solid ${C.border}`,
  borderRadius: "8px",
  marginTop: "6px",
  maxHeight: "220px",
  overflowY: "auto",
};
const optionStyle = {
  display: "block",
  width: "100%",
  textAlign: "left",
  border: "none",
  background: "transparent",
  cursor: "pointer",
  padding: "8px 12px",
  fontSize: "12px",
  color: C.text,
  lineHeight: 1.4,
};
const noteStyle = {
  fontSize: "11px",
  fontWeight: "700",
  color: C.textSub,
  padding: "8px 12px",
};

export default function Icd10SearchField({ term, code, placeholder, onTermChange, onSelect }) {
  const [focused, setFocused] = useState(false);
  const mouseDownInList = useRef(false);

  const options = useMemo(() => (code ? [] : searchIcd10(term)), [term, code]);
  const query = (term || "").trim();
  const showList = !code && focused && query.length >= 1;

  return (
    <div style={{ position: "relative" }}>
      <IpdTextField
        fullWidth
        value={term || ""}
        placeholder={placeholder}
        onChange={(e) => onTermChange(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => {
          setTimeout(() => {
            if (!mouseDownInList.current) setFocused(false);
            mouseDownInList.current = false;
          }, 150);
        }}
        InputProps={
          code
            ? {
                endAdornment: (
                  <button
                    type="button"
                    title="Clear and search again"
                    onClick={() => onTermChange("")}
                    style={{ border: "none", background: "transparent", cursor: "pointer", display: "flex", padding: 0 }}
                  >
                    <SvgIcon name="x" size={14} color={C.textSub} />
                  </button>
                ),
              }
            : undefined
        }
      />

      {showList && (
        <div style={listStyle} onMouseDown={() => { mouseDownInList.current = true; }}>
          {options.length === 0 ? (
            <div style={{ ...noteStyle, color: C.danger }}>
              No ICD-10 match. Search by code (e.g. I20.0) or description.
            </div>
          ) : (
            options.map((opt) => (
              <button
                key={opt.code}
                type="button"
                style={optionStyle}
                onClick={() => onSelect(opt)}
                onMouseEnter={(e) => { e.currentTarget.style.background = C.accent; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
              >
                {opt.display}
                <span style={{ color: C.textSub, fontFamily: "monospace", marginLeft: "8px" }}>
                  {opt.code}
                </span>
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}
